'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Common = require('components/Common');

var _Markup = require('components/Common/Markup');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* injects from baggage-loader */
var styles = require('./EditorLink.pcss');

var EditorLink = function (_Component) {
  _inherits(EditorLink, _Component);

  function EditorLink(props) {
    _classCallCheck(this, EditorLink);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(EditorLink).call(this, props));

    _this.state = {
      link: props.defaultUrl || '',
      text: props.defaultText || ''
    };
    return _this;
  }

  _createClass(EditorLink, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: styles.link },
        _react2.default.createElement(
          'div',
          { className: styles.title },
          _react2.default.createElement(
            _Markup.HeadingMedium,
            { noMargins: true },
            'Add link'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.field },
          _react2.default.createElement(
            'div',
            { className: styles.label },
            'Link to:'
          ),
          _react2.default.createElement('input', { className: styles.input, value: this.state.link,
            onChange: function onChange(e) {
              return _this2.setState({ link: e.target.value });
            } })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.field },
          _react2.default.createElement(
            'div',
            { className: styles.label },
            'Display text:'
          ),
          _react2.default.createElement('input', { className: styles.input, value: this.state.text,
            onChange: function onChange(e) {
              return _this2.setState({ text: e.target.value });
            } })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.controls },
          _react2.default.createElement(
            'div',
            { className: styles.cancel },
            _react2.default.createElement(
              _Common.Button,
              { onClick: this.props.cancel, light: true },
              'Cancel'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.delete },
            _react2.default.createElement(
              _Common.Button,
              { onClick: function onClick() {
                  return _this2.props.submit({ link: _this2.state.link, text: _this2.state.text });
                }, light: true },
              'Ok'
            )
          )
        )
      );
    }
  }]);

  return EditorLink;
}(_react.Component);

exports.default = EditorLink;


EditorLink.propTypes = {
  defaultText: _react.PropTypes.string,
  defaultUrl: _react.PropTypes.string,
  submit: _react.PropTypes.func.isRequired,
  cancel: _react.PropTypes.func.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./app/components/Popups/EditorLink/EditorLink.js
// module id = 566
// module chunks = 1